import { H5 } from 'foundations-components/transitional/components/H5';
import ErrorsCountBanner, { getLogicGroupValidationErrorsCount } from '../common/ErrorsCountBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import TestFilters from './TestFilters';
import ViewerEditButton from './ViewerEditButton';
import ViewerTestFiltersButton from './ViewerTestFiltersButton';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerHeader = () => {
  const {
    isInEditMode,
    isInTestFilters,
    internalDraftValue,
    props: {
      additionalHeaderButtons,
      hideHeader,
      uiMessages,
      isReadOnly,
      showTestFilters: showTestFiltersProp
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    isTestFiltersEnabled
  } = useStrategy();
  if (isReadOnly && !uiMessages.filtersHeaderLabel) {
    if (hideHeader) {
      return null;
    }
    return /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "400",
      as: "div"
    });
  }
  const showTestFilters = isTestFiltersEnabled && (isInTestFilters || showTestFiltersProp);
  const errorsContent = isInEditMode && getLogicGroupValidationErrorsCount(internalDraftValue) > 0 ? /*#__PURE__*/_jsx(ErrorsCountBanner, {}) : null;
  if (hideHeader) {
    if (!showTestFilters && !errorsContent) {
      return null;
    }
    return /*#__PURE__*/_jsxs(FoundationsView, {
      padding: "400",
      as: "div",
      children: [showTestFilters && /*#__PURE__*/_jsx(TestFilters, {}), errorsContent]
    });
  }
  return /*#__PURE__*/_jsxs(FoundationsView, {
    padding: "400",
    as: "div",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      minBlockSize: "26px",
      children: [/*#__PURE__*/_jsx(H5, {
        margin: "0",
        children: uiMessages && uiMessages.filtersHeaderLabel ? uiMessages.filtersHeaderLabel : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.viewerPanelHeader"
        })
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        justify: "end",
        children: [additionalHeaderButtons, isTestFiltersEnabled && typeof showTestFiltersProp === 'undefined' && /*#__PURE__*/_jsx(ViewerTestFiltersButton, {}), /*#__PURE__*/_jsx(ViewerEditButton, {})]
      })]
    }), showTestFilters && /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(TestFilters, {})
    }), errorsContent]
  });
};
export default ViewerHeader;